import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { MatSelectChange } from '@angular/material/select';

@Component({
  selector: 'app-instructions',
  templateUrl: './instructions.component.html',
  styleUrls: ['./instructions.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class InstructionsComponent implements OnInit {
  selected = 'en';
  langs = ['en', 'ru'];
  start = true;
  constructor(private router: Router, private translateService: TranslateService) { }

  ngOnInit(): void {
    const defaultLang = localStorage.getItem('language') || this.translateService.getBrowserLang();
    if (this.langs.includes(defaultLang) ) {
      this.selected = defaultLang;
    } else {
      this.selected = 'en';
    }
    this.translateService.setDefaultLang(this.selected);
    localStorage.setItem('language', this.selected);
    this.translateService.use(this.selected);
  }

  selectLanguage(lang: MatSelectChange): void {
    this.translateService.setDefaultLang(lang.value);
    localStorage.setItem('language', lang.value);
    this.translateService.use(localStorage.getItem('language'));
  }

  startGame(): void {
    this.start = false;
  }

  next(): void {
    this.router.navigate(['/', 'players']);
  }
}
